import React from 'react';
import { HStack, Stack } from '@chakra-ui/core';
import { SchemaBuilderProps } from './formBuilderSchema';
import FormElementTextBuilder from './FormElementTextBuilder';
import LabelSchemaBuilder from './LabelSchemaBuilder';
import InputPreview from './InputPreview';
import { useTranslation } from 'react-i18next';

export default function DatePickerSchemaBuilder(props: SchemaBuilderProps) {
  const { t } = useTranslation('hrFormTemplate');

  return (
    <Stack>
      <HStack justify="space-between">
        <LabelSchemaBuilder {...props} />
        {props?.labelRightRenderer}
      </HStack>
      <FormElementTextBuilder {...props} placeholder={t('formBuilder.editorPlaceholder.date')} />
      <InputPreview value={props?.defaultValue?.previewPlaceholders?.placeholder ?? 'MM-DD-YYYY'} />
    </Stack>
  );
}
